<template>
    <section v-if="values && values.length" class="IVP">
      <div class="IVP__inner">
  
        <h3 class="IVP__title">{{ infoTitle }}</h3>
  
        <p v-if="infoPara1" class="IVP__p">{{ infoPara1 }}</p>
        <p v-if="infoPara2" class="IVP__p">{{ infoPara2 }}</p>
  
        <h4 v-if="values && values.length" class="IVP__subtitle">{{ valuesTitle }}</h4>
  
        <div v-if="values && values.length" class="IVP__values" :class="{ 'is-scroll': isMobile }">
          <div v-for="v in values" :key="v.id || v.label" class="IVP__value">
            <img v-if="v.icon_url" :src="v.icon_url" alt="" class="IVP__icon" />
            <div class="IVP__label">{{ v.label }}</div>
          </div>
        </div>
  
      </div>
    </section>
  </template>
  
  <script>
  export default {
    name: 'InfoValuesBlock',
    props: {
      infoTitle:   { type: String, default: 'INFORMATIONS COMPLÉMENTAIRES' },
      infoPara1:   { type: String, default: '' },
      infoPara2:   { type: String, default: '' },
      valuesTitle: { type: String, default: 'LEURS VALEURS' },
      values:      { type: Array,  default: () => [] }
    },
    data(){ return { isMobile: false } },
    mounted(){
      const check = () => { this.isMobile = window.matchMedia('(max-width: 860px)').matches }
      check(); window.addEventListener('resize', check)
    },
    beforeDestroy(){ window.removeEventListener('resize', this.check) }
  }
  </script>
  
  <style scoped>
  .IVP{
    background:#f1f6f3; /* subtle green */
    border-radius:16px;
    padding: clamp(22px, 4vw, 46px);
    margin: clamp(12px, 3vw, 30px) 0;
  }
  .IVP__inner{ max-width: 1260px; margin: 0 auto; text-align: center; }
  .IVP__title{
    text-align:center; margin:0 0 18px; color:#0e0e0e;
    font-family: 'Merriweather';
    font-weight: 400;
    font-size: 24px;
  }
  .IVP__p{
    max-width: 1200px;
    margin: 0 auto clamp(16px,2.4vw,24px);
    font: 400 clamp(15px,1.25vw,20px)/1.55 'Merriweather',serif;
    color:#1b2c25;
  }
  .IVP__subtitle{
    font: 800 clamp(16px, 1.9vw, 22px)/1.2 'Raleway',sans-serif;
    color:#0c1b16; margin: clamp(18px,3vw,28px) 0 clamp(8px,1.2vw,12px);
  }
  
  /* Values row */
  .IVP__values{
    display:grid; grid-template-columns: repeat(3, 1fr);
    gap: clamp(22px, 6vw, 140px);
    align-items: start; justify-items: center;
    margin-top: clamp(12px, 2vw, 20px);
  }
  .IVP__value{ display:grid; gap:12px; justify-items:center; }
  .IVP__icon{ width: clamp(80px, 8vw, 120px); height: clamp(80px, 8vw, 120px); object-fit: contain; }
  .IVP__label{
    font: 500 clamp(15px,1.15vw,20px)/1.35 'Merriweather',serif;
    color:#0f201a;
  }
  
  /* Mobile: stacked text; icons row scrollable */
  @media (max-width: 860px){
    .IVP{ padding: 26px 18px 32px; }
    .IVP__p{ max-width: 640px; }
    .IVP__values{
      display:flex; gap: 28px; overflow-x:auto; padding-bottom: 6px;
      scroll-snap-type: x mandatory;
    }
    .IVP__values.is-scroll::-webkit-scrollbar{ height:6px }
    .IVP__values.is-scroll::-webkit-scrollbar-thumb{ background:#cfe0d8;border-radius:999px }
    .IVP__value{ min-width: 180px; scroll-snap-align: center; }
    .IVP__icon{ width: 120px; height: 120px; }
  }
  </style>
  